// Translations: English, German and French, as in the legacy client (spec §30). Keys follow the
// area.component.element pattern.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

export const languages = ['en', 'de', 'fr'] as const;

const browser = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : 'en';

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, de: { translation: de }, fr: { translation: fr } },
  lng: (languages as readonly string[]).includes(browser) ? browser : 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React escapes output
});

export default i18n;
